export default __webpack_public_path__ + "static/media/increase-size.97e9cd75.svg";